import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../ducks";
import cartDuck from "../ducks/cart";
import { CatalogItem } from "../queries/auto-generated/schemas";
import { useItemAvailability } from "./useItemAvailability";

const useCart = () => {
  const dispatch = useDispatch()
  const {isAvailableAtLocation} = useItemAvailability()

  const { lineItems } = useSelector((state: RootState) => state.cart);
  const cart = useSelector((state: RootState) => state.cart);
  const catalogItems = useSelector(
    (state: RootState) => state.catalog.data.items
  );

  const cartItemCount = lineItems.reduce((previous, current) => {
    return previous + current.quantity;
  }, 0);

  const updateCartAvailability = (locationId: string) => {
    const itemsToRemove: string[] = [];
    // Get all items in the cart and check if they are available at this location
    cart.lineItems.forEach((lineItem) => {
      const catalogItem = catalogItems[lineItem.item_id];
      if (!catalogItem || !isAvailableAtLocation(catalogItem, locationId)) {
        itemsToRemove.push(lineItem.item_id);
      }
    });
    if (itemsToRemove.length > 0) {
      dispatch(
        cartDuck.actions.removeMultipleByJooId({ jooIds: itemsToRemove })
      );
      notification.open({
        placement: "bottomRight",
        key: "remove-items-notification",
        message: (
            "Some items in your cart are no longer available at this location and have been removed."
        ),
        duration: 0
      }); 
    }
  };

  const checkCartAvailabilityAtLocation = (locationId: string) => {
    const unavailable: CatalogItem[] = [];
    const itemsToRemove: string[] = [];
    cart.lineItems.forEach((lineItem) => {
      const catalogItem = catalogItems[lineItem.item_id];
      if (!catalogItem || !isAvailableAtLocation(catalogItem, locationId)) {
        if (catalogItem) {
          unavailable.push(catalogItem);
        }
        itemsToRemove.push(lineItem.item_id);
      }
    });
    return {
      unavailable,
      itemsToRemove,
      hasUnavailableItems: itemsToRemove.length > 0,
    }
  }

  return {
    cartItemCount,
    updateCartAvailability,
    checkCartAvailabilityAtLocation
  };
};

export default useCart;
